export interface TellUsAboutYourselfData {
    firstName: string;
    middleName: string;
    lastName: string;
    suffix: string;
    birthDate: any;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: any;
    zipCode: string;
    phoneNumber: string;
    ssnNumber: string;
    email: string;
    preferredName: string;
    isUSCitizen: boolean | null;
    citizenship: string;
}

export const TellUsAboutYourselfPrimaryDevData: TellUsAboutYourselfData = {
    firstName: "John",
    middleName: "Stephen",
    lastName: "Smith",
    suffix: "",
    preferredName: "JS",
    birthDate: new Date(1975, 8, 24, 0, 0, 0),
    addressLine1: "222333 PEACHTREE PLACE",
    addressLine2: "Apt 123",
    city: "Atlanta",
    state: 34,
    zipCode: "30318",
    phoneNumber: "5554322341",
    ssnNumber: "",
    email: "",
    isUSCitizen: null,
    citizenship: ""
}

export const TellUsAboutYourselfSecondaryDevData: TellUsAboutYourselfData = {
    firstName: "David",
    middleName: "Stephen",
    lastName: "Jones",
    suffix: "",
    preferredName: "DJ",
    birthDate: new Date(1975, 8, 24, 0, 0, 0),
    addressLine1: "111555 PEACHTREE ROAD",
    addressLine2: "Apt 321",
    city: "Atlanta",
    state: 0,
    zipCode: "30318",
    phoneNumber: "9998881234",
    ssnNumber: "789451231",
    email: "djones@gmail.com",
    isUSCitizen: null,
    citizenship: ""
}

export const TellUsAboutYourselfEmptyData: TellUsAboutYourselfData = {
    firstName: "",
    middleName: "",
    lastName: "",
    suffix: "",
    preferredName: "",
    birthDate: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: 0,
    zipCode: "",
    phoneNumber: "",
    ssnNumber: "",
    email: "",
    isUSCitizen: null,
    citizenship: ""
}

export interface EmploymentDetailsData {
    incomeSource: number,
    occupation: number,
    employerCountry: number,
    annualIncome: number,
    taxPayerCertificationCheckbox: boolean
}

export const EmploymentDetailsPrimaryDevData: EmploymentDetailsData = {
    incomeSource: 2,
    occupation: 7,
    employerCountry: 0,
    annualIncome: 3,
    taxPayerCertificationCheckbox: true
}

export const EmploymentDetailsSecondaryDevData: EmploymentDetailsData = {
    incomeSource: 1,
    occupation: 2,
    employerCountry: 0,
    annualIncome: 1,
    taxPayerCertificationCheckbox: true
}

export const EmploymentDetailsEmptyData: EmploymentDetailsData = {
    incomeSource: 0,
    occupation: 0,
    employerCountry: 0,
    annualIncome: 0,
    taxPayerCertificationCheckbox: false
}
